export const isBookingPortal = process.env['NUXT_ENV_IS_BOOKING_PORTAL'] === 'true';
